import lazyLoad from '@loadable/component'

import createPlugin from './createPlugin'

import CarouselRenderer from '@peracto/peracto-blocks-tailwind/dist/content/Carousel/Renderer/CarouselRenderer'

const CarouselForm = lazyLoad(() => import('./Form/CarouselForm'))

const carouselPlugin = settings =>
    createPlugin({
        Renderer: CarouselRenderer,
        Controls: CarouselForm,
        ...settings,
    })

const carousel = carouselPlugin()
export default carousel

export { carouselPlugin, CarouselRenderer }
